<template>
  <CFooter :fixed="false">
    
    <div class="mfs-auto">
      <span class="mr-1" target="_blank">Powered by</span>
      <a href="https://www.makenai.es/"><img style="height: 35px; width: auto;" src="../assets/icons/makenai.png"/></a>
    </div>
  </CFooter>
</template>

<script>
export default {
  name: 'TheFooter'
}
</script>
